import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.30175 1.20258L13.0176 2.19824L15.5835 11.168L20.5424 12.4967C21.8761 12.8541 22.6675 14.2249 22.3102 15.5586C21.9528 16.8922 20.582 17.6837 19.2483 17.3263L1.55273 12.5848L2.01217 5.461L5.1862 6.31147L5.82767 8.55391L9.16304 9.44762L9.30175 1.20258ZM1.99991 19H21.9999V21H1.99991V19Z"}}]};

const FlightLandingFilled = Vue.extend<IconProps>({
  name: 'FlightLandingFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'flight-landing-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FlightLandingFilled;
